/**
 * Canonical JSON: the form a value is hashed in.
 *
 * Two runs that serialise the same scope or report must produce the same bytes, or a hash
 * recorded at approval could never be checked again. `JSON.stringify` keeps insertion order,
 * which depends on how an object happened to be built; this sorts keys at every level instead.
 * Array order is kept, because in a scope or a report order carries meaning.
 *
 * `undefined` is dropped, as `JSON.stringify` would drop it, so an absent optional field and a
 * missing one hash the same. Hashing lives on the server (Node's `crypto`); this module stays
 * pure so the browser and the server agree on what is being hashed.
 */
export function canonicalJson(value) {
    return JSON.stringify(sortKeys(value));
}
function sortKeys(value) {
    if (Array.isArray(value))
        return value.map(sortKeys);
    if (value === null || typeof value !== 'object')
        return value;
    const out = {};
    for (const key of Object.keys(value).sort()) {
        const child = value[key];
        if (child !== undefined)
            out[key] = sortKeys(child);
    }
    return out;
}
/** A digest as shown to a person: enough to compare by eye, short enough to read. */
export const shortDigest = (digest) => digest.slice(0, 12);
//# sourceMappingURL=digest.js.map